import axios from 'axios';

const KEY = 'practcomOfficeId';
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const getSelectedOffice = () => sessionStorage.getItem(KEY) || '';
export const clearSelectedOffice = () => sessionStorage.removeItem(KEY);
export const hasPickedOffice = () => sessionStorage.getItem(KEY) !== null;

export function openOffice(officeId) {
  sessionStorage.setItem(KEY, officeId || '');
  window.location.assign('/');
}

const addHeader = (config) => {
  const id = getSelectedOffice();
  if (id && (!config.url || config.url.startsWith('/') || config.url.startsWith(BACKEND) || config.baseURL)) {
    config.headers = config.headers || {};
    config.headers['X-Office-Id'] = id;
  }
  return config;
};

export function installOfficeHeader(...instances) {
  [axios, ...instances].forEach((i) => i.interceptors.request.use(addHeader));
  if (window.__officeFetchPatched) return;
  window.__officeFetchPatched = true;
  const orig = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const url = typeof input === 'string' ? input : input?.url || '';
    const id = getSelectedOffice();
    if (id && url.startsWith(BACKEND) && url.includes('/api/')) {
      const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined) || {});
      headers.set('X-Office-Id', id);
      return orig(input, { ...init, headers });
    }
    return orig(input, init);
  };
}
